import { DEFAULT_LOCALE, hasLocalePrefix } from './locales';

const EXTERNAL_PROTOCOL_REGEX = /^(https?:|mailto:|tel:|data:|blob:|ftp:)/i;

export const localizeHref = (
  href: string | undefined | null,
  locale: string | undefined | null,
  defaultLocale: string = DEFAULT_LOCALE
): string => {
  if (typeof href !== 'string' || href.length === 0) return href ?? '';

  if (href === '#' || href.startsWith('#')) return href;

  if (EXTERNAL_PROTOCOL_REGEX.test(href)) return href;

  if (!href.startsWith('/')) return href;

  if (!locale || locale === defaultLocale) return href;

  if (hasLocalePrefix(href)) return href;

  return `/${locale}${href}`;
};

export default localizeHref;
